import React, { useRef } from "react";
import styled from '@emotion/styled';
import propTypes from 'prop-types';
import RadioCheck from '../../../assets/icons/radio-button.svg';
import RadioCheckMobile from '../../../assets/icons/radio-button-mobile.svg';
import RespImg from "../../ui/RespImg";
import { theme } from "../../../themes/default-theme";
import { ReactSVG } from 'react-svg';
import PdfIcon from '../../../assets/icons/pdf-icon.svg';
import RadioDot from '../../../assets/icons/radio-dot.svg';

const RadioButtonWrappingLabel = styled.label`
  display: flex;
  cursor: pointer;
  ${props => props.flex == 1 && `
      position: relative;
      align-items: center;
  `}
  ${props => props.hasBorder == 1 && `
    & {
      border-radius: 8px;
      outline: 2px solid ${theme.palette.vividBlue};
      ${theme.breakpoints.up('md')} {
        margin-right: 2px!important;

      }
      ${theme.breakpoints.down('sm')} {
        margin-right: 2px!important;
        margin-left: 2px!important;
      }
      
    }
  `}
  ${props => props.flex == 1 && props.hasPrice == 1 && `
      > span {
        &:last-child {
          flex: auto;
          margin-left: 16px;
          text-align: right;
        }
        &
      }
  `}
  ${theme.breakpoints.up('md')} {
    picture {
        margin-bottom: 10px;
        &, img {
            width: auto;
        }
      }
      ${props => props.flex == 1 && `
          picture {
            margin: 0 16px 0 26px;
          }
      `}
  }
  ${theme.breakpoints.down('sm')} {
    picture {
        margin-bottom: 8px;
        &, img {
            width: 42px;
            height: 56px;
            object-fit: cover;
        }
      }
      ${props => props.flex == 1 && `
        picture {
          margin: 0 8px 0 16px;
          &, img {
            width: auto;
            height: auto;
          }
        }
      `}
  }

`;

const RadioButtonInput = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  ${props => props.roundRadioDot == 0 && props.flex == 1 && `
  & + span {
    padding: 0.25rem;
    display: flex;
    align-items: center;
    &:before {
      content: "";
      font-size: 1rem;
      display: inline-block;
      background: inherit;
      border: 1px solid #CAC6C5;
      border-radius: 59px;
      transition: 0.2s all linear;
      ${theme.breakpoints.up('md')} {
        width: 25px;
        height: 25px;
      }
      ${theme.breakpoints.down('sm')} {
        width: 19px;
        height: 19px;
        font-size: 0;
      }
    }
  }
  &:checked + span::before {
    background: #0170D4;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    ${theme.breakpoints.up('md')} {
        content: url(${RadioCheck});
      }
      ${theme.breakpoints.down('sm')} {
        content: url(${RadioCheckMobile});
        
      }
   }
 `}
 ${props => props.borderStyle == 1 && `
  + span {
    width: 100%;
    height: 100%;
    position: relative;
  } 
  &:checked + span::after {
    position: absolute;
    width: calc(100% + 20px);
    height: 100%;
    outline: 2px solid  #0170D4;
    content: '';
    display: block;
    left: -10px;
    border-radius: 8px;
   }
 `}
  ${props => props.roundRadioDot == 0 && props.flex == 0 && `
  & + span {
    padding: 0.25rem;
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
    &:before {
      content: "";
      font-size: 1rem;
      display: inline-block;
      background: inherit;
      border: 1px solid #575757;
      border-radius: 59px;
      transition: 0.2s all linear;
      ${theme.breakpoints.up('md')} {
        width: 25px;
        height: 25px;
      }
      ${theme.breakpoints.down('sm')} {
        width: 19px;
        height: 19px;
        font-size: 0;
      }
    }
  }
  &:checked + span::before {
    background: #0170D4;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    ${theme.breakpoints.up('md')} {
        content: url(${RadioCheck});
      }
      ${theme.breakpoints.down('sm')} {
        content: url(${RadioCheckMobile});
      }
   }
 `}
  ${props => props.roundRadioDot == 1 && `
  & + span {
    padding: 0.25rem;
    display: flex;
    gap: 15px;
    align-items: center;
    &:before {
      font-size: 1rem;
      display: inline-block;
      background: #FFFFFF;
      border: 1px solid #D6D6D6;
      border-radius: 55px;
      transition: 0.2s all linear;
      content: '';
      ${theme.breakpoints.up('md')} {
        width: 32px;
        height: 32px;
      }
      ${theme.breakpoints.down('sm')} {
        width: 24px;
        height: 24px;
        font-size: 0;
      }
    }
  }
  &:checked + span::before {
      display: flex;
      justify-content: center;
      align-items: center;
      content: url(${RadioDot});
      background-position: center;
      ${theme.breakpoints.down('sm')} {
        padding-top: 10px;
      }
    }

  `}
`;

const newRadioDefaultPropChanged = () => { };

const NewRadio = (props) => {
  props = {
    ...props,
    changed: typeof props.changed === "undefined" ? newRadioDefaultPropChanged : props.changed,
    id: typeof props.id === "undefined" ? '' : props.id,
    isSelected: typeof props.isSelected === "undefined" ? null : props.isSelected,
    label: typeof props.label === "undefined" ? null : props.label,
    value: typeof props.value === "undefined" ? null : props.value,
    thumbnail: typeof props.thumbnail === "undefined" ? null : props.thumbnail,
    hasThumbnail: typeof props.hasThumbnail === "undefined" ? null : props.hasThumbnail,
    pdfIcon: typeof props.pdfIcon === "undefined" ? null : props.pdfIcon,
    roundRadioDot: typeof props.roundRadioDot === "undefined" ? null : props.roundRadioDot,
    showOptionLabel: typeof props.showOptionLabel === "undefined" ? null : props.showOptionLabel,
    flex: typeof props.flex === "undefined" ? null : props.flex,
    price: typeof props.price === "undefined" ? null : props.price,
    showPrice: typeof props.showPrice === "undefined" ? null : props.showPrice,
    showLabelOnly: typeof props.showLabelOnly === "undefined" ? null : props.showLabelOnly,
    labelBorder: typeof props.labelBorder === "undefined" ? null : props.labelBorder,
    borderStyle: typeof props.borderStyle === "undefined" ? null : props.borderStyle
  };

  const { changed, id, isSelected, label, value, thumbnail, hasThumbnail, pdfIcon, roundRadioDot, showOptionLabel, flex, price, showPrice, showLabelOnly, labelBorder, borderStyle } = props;

  const inputRef = useRef();

  const handleInputRef = () => {
    inputRef.current.click();
  };

  return (
    <RadioButtonWrappingLabel onClick={handleInputRef} flex={flex ? 1 : 0} hasPrice={showPrice ? 1 : 0} hasBorder={flex && labelBorder ? 1 : 0}>
      <RadioButtonInput
        ref={inputRef}
        id={id}
        onChange={changed}
        value={value}
        type="radio"
        checked={isSelected}
        roundRadioDot={roundRadioDot ? 1 : 0}
        flex={flex ? 1 : 0}
        borderStyle={borderStyle ? 1 : 0}
      />
      {(thumbnail || hasThumbnail) &&
        <>
        {thumbnail &&
          <span htmlFor={id}>
            <RespImg
              {...thumbnail}
              lazyLoad={false}
            />
          </span>
        }
        {showOptionLabel && label && <span style={{gap: flex && !thumbnail ? '10px' : ''}}>{label}</span>}
        {showPrice ?
          price ?
            // <span>+${price}</span>
            <span></span>
          :
            <span></span>
          :
          ''
        }
        </>
      }
      {
        pdfIcon &&
        <span htmlFor={id}>
          {pdfIcon && <ReactSVG src={PdfIcon}></ReactSVG>}
          {showOptionLabel && label && <span>{label}</span>}
        </span>
      }
      {
        showLabelOnly &&
        <span htmlFor={id}>
          {showOptionLabel && label && <span>{label}</span>}
        </span>
      }
    </RadioButtonWrappingLabel>
  );
};

NewRadio.propTypes = {
  changed: propTypes.func,
  id: propTypes.string,
  isSelected: propTypes.bool,
  label: propTypes.string,
  value: propTypes.string,
  thumbnail: propTypes.object,
  hasThumbnail: propTypes.bool,
  pdfIcon: propTypes.bool,
  roundRadioDot: propTypes.bool,
  showOptionLabel: propTypes.bool,
  flex: propTypes.bool,
  price: propTypes.any,
  showPrice: propTypes.bool,
  showLabelOnly: propTypes.bool,
  labelBorder: propTypes.any,
  borderStyle: propTypes.bool
}

export default NewRadio;